/**
 * Boolean toggle primitive. Same visual weight/motion language as Button
 * (design principle #5: color + displacement animate every state change,
 * never a flat jump cut) and same `loading` contract as Button (design
 * principle #1: an action in flight must always look like it's in
 * flight, never inert).
 */
interface SwitchProps {
  checked: boolean
  onChange: (next: boolean) => void
  loading?: boolean
  disabled?: boolean
  label: string
}

export function Switch({ checked, onChange, loading = false, disabled = false, label }: SwitchProps) {
  const isDisabled = disabled || loading

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={isDisabled}
      onClick={() => onChange(!checked)}
      style={{
        position: "relative",
        width: 44,
        height: 24,
        flexShrink: 0,
        borderRadius: "var(--radius-full)",
        border: "1px solid var(--border-default)",
        background: checked ? "var(--brand-primary)" : "var(--bg-hover)",
        transition: `background-color var(--duration-small) var(--ease-out)`,
        cursor: isDisabled ? "not-allowed" : "pointer",
        opacity: isDisabled ? 0.6 : 1,
        padding: 0,
      }}
    >
      <span
        style={{
          position: "absolute",
          top: 2,
          left: checked ? 22 : 2,
          width: 18,
          height: 18,
          borderRadius: "var(--radius-full)",
          background: "var(--text-on-brand)",
          boxShadow: "var(--shadow-sm)",
          transition: `left var(--duration-small) var(--ease-out)`,
        }}
      />
    </button>
  )
}
